
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Emotion } from "../interfaces/Interfaces";
import DisplayAnalysis from "./DisplayAnalysis.vue";
import DisplayOverview from "./DisplayOverview.vue";
import ScenesSelection from "./ScenesSelection.vue";
import { mapGetters, mapMutations } from "vuex";

@Component({
  components: {
    DisplayAnalysis,
    DisplayOverview,
    ScenesSelection,
  },
  computed: {
    ...mapGetters("controller", {
      isMultiselection: "isMultiselection",
    }),
    ...mapGetters("stimulus", {
      getProjectName: "getProjectName",
    }),
    ...mapGetters("stimulus", {
      getVideoName: "getVideoName",
    }),
    ...mapGetters("stimulus", {
      getVideoFullName: "getVideoFullName",
    }),
    ...mapGetters("stimulus", {
      getMultipleEmotions: "getMultipleEmotions",
    }),
    ...mapGetters("stimulus", {
      getEmotionSettings: "getEmotionSettings",
    }),
    ...mapGetters("stimulus", {
      isClientMode: "isClientMode",
    }),
    ...mapGetters("stimulus", {
      getYMaxValue: "getYMaxValue",
    }),
  },
  methods: {
    ...mapMutations("controller", {
      toggleMultiselection: "toggleMultiselection",
    }),
  },
})
export default class DisplayController extends Vue {
  private selectedEmotion: string = "Happiness";
  private selectedMode: string = "Analysis";
  private isMultiselection!: boolean;
  private toggleMultiselection!: () => boolean;
  private getVideoName!: string;
  private getVideoFullName!: string;
  private getProjectName!: string;
  private getMultipleEmotions!: [];
  private getEmotionSettings!: [];
  private multipleEmotions: string[] = [];
  private emotionSettings: String[] = [];
  private isClientMode!: boolean;
  private getYMaxValue!: number;

  @Prop() private emotions!: Emotion[];
  @Prop() private emotionsWithFilters!: Emotion[];

  mounted() {
    for (let i in this.getEmotionSettings) {
      let setting: String = this.getEmotionSettings[i];
      this.emotionSettings.push(setting);
    }

    if (!this.isClientMode) return;

    if (Number(this.getMultipleEmotions.length) === 1) {
      let emotion: any = this.getMultipleEmotions.pop();
      this.selectedEmotion = emotion.charAt(0).toUpperCase() + emotion.slice(1);
      // this.emotionSettings = ["ymax", "age", "gender"]
      this.emotionSettings = this.getEmotionSettings;
      return;
    }

    // Enable multiselection before populating the list so child graphs format
    // with the correct mode on first render.
    this.toggleMultiselection();

    for (let idx in this.getMultipleEmotions) {
      let emotion: String = this.getMultipleEmotions[idx];
      this.multipleEmotions.push(
        emotion.charAt(0).toUpperCase() + emotion.slice(1)
      );
    }
  }

  private get videoUrl(): string {
    return `${process.env.VUE_APP_S3_VIDEO_URL}/${this.getVideoFullName}`;
  }

  private get videoLengthInDeciseconds(): number {
    const length: number = this.emotions[0].data.length;
    return length;
  }

  private neutralIsDisabled(emotion: string): boolean {
    if (emotion === "Neutral" && this.selectedMode === "Overview") return true;
    else return false;
  }

  private onSelectEmotion(emotion: string, event: MouseEvent): void {
    if (this.isMultiselection) {
      if (!this.multipleEmotions.includes(emotion)) {
        this.multipleEmotions.push(emotion);
      } else {
        this.multipleEmotions = this.multipleEmotions.filter(
          (e: string) => e !== emotion
        );
      }
    } else {
      this.selectedEmotion = emotion;
    }
  }

  // Handles for multiple active classes in multiselection mode
  private isActive(emotion: string): boolean {
    if (this.isMultiselection && this.multipleEmotions.includes(emotion)) {
      return true;
    } else return false;
  }
  private isNonActive(emotion: string): boolean {
    if (this.isMultiselection && !this.multipleEmotions.includes(emotion)) {
      return true;
    } else return false;
  }

  @Watch("isMultiselection")
  private addSelectedEmotionToMultiselection(): void {
    if (this.isClientMode) return;

    if (this.isMultiselection === true && this.selectedEmotion !== "Neutral") {
      this.multipleEmotions.push(this.selectedEmotion);
    } else {
      this.multipleEmotions = [];
    }
  }

  private onSelectMode(mode: string): void {
    this.selectedMode = mode;
    if (mode === "Overview") {
      if (this.isMultiselection === false) {
        this.toggleMultiselection();
      }
      this.multipleEmotions = [
        "Happiness",
        "Surprise",
        "Disgust",
        "Sadness",
        "Anger",
        "Fear",
        "Contempt",
        "Attention",
      ];
    } else {
      if (this.isMultiselection === true) {
        this.toggleMultiselection();
        this.multipleEmotions = [];
      }
    }
  }

  private handleMultiselection(): void {
    this.toggleMultiselection();
  }
}
